// extracted by mini-css-extract-plugin
export default {"full":"Subscription_full__1iCU1","form":"Subscription_form__xflKB","secTitle":"Subscription_secTitle__BEtRr","helper":"Subscription_helper__Ij+mn"};